import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateClinicalReviewDetails } from '../../../../../../services/CaseManagementService/caseManageSlice';

const statusOptions = [
  'Incomplete',
  'Pending',
  'Complete',
  'Not Required',
  'Does Not Support'
];

const ImagingReportField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const handleChange = (value: string) => {
    dispatch(updateClinicalReviewDetails({
      imagingReport: value
    }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Imaging Report</InputLabel>
      <Select
        value={currentCase?.clinicalReview?.imagingReport || 'Incomplete'}
        onChange={(e) => handleChange(e.target.value)}
        label="Imaging Report"
      >
        {statusOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ImagingReportField;
